const runtimeConfig =
  typeof window !== 'undefined' && window.__APP_CONFIG__
    ? window.__APP_CONFIG__
    : {};

const API_PROTOCOL =
  runtimeConfig.API_PROTOCOL || process.env.REACT_APP_API_PROTOCOL || 'http';
const API_HOST = runtimeConfig.API_HOST || process.env.REACT_APP_API_HOST || 'localhost';
const API_PORT = runtimeConfig.API_PORT || process.env.REACT_APP_API_PORT || '8080';

const isDefaultPort =
  (API_PROTOCOL === 'https' && API_PORT === '443') ||
  (API_PROTOCOL === 'http' && API_PORT === '80');
export const API_BASE_URL = isDefaultPort
  ? `${API_PROTOCOL}://${API_HOST}`
  : `${API_PROTOCOL}://${API_HOST}:${API_PORT}`;

export const apiUrl = (path = '') => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};

export const API_FILEIO_BASE_URL =
  runtimeConfig.API_FILEIO_BASE_URL ||
  process.env.REACT_APP_API_FILEIO_BASE_URL ||
  'https://localhost:4000';

const normalizedFileIoBaseUrl = API_FILEIO_BASE_URL.replace(/\/+$/, '');
export const fileUploadUrl = process.env.REACT_APP_FILE_UPLOAD_URL || 'https://fileio.bandtangocc.com/upload';
//   runtimeConfig.FILE_UPLOAD_URL ||
//   `${normalizedFileIoBaseUrl}/upload`;